export function serialize (obj = null) {
  let string = ''
  if (obj) {
    Object.keys(obj).forEach(x => {
      if (obj[x]) {
        if (Array.isArray(obj[x])) {
          obj[x].forEach(value => {
            if (value.toISOString) string += `&${x}[]=${encodeURIComponent(value.toISOString())}`
            else string += `&${x}[]=${encodeURIComponent(value)}`
          })
        } else {
          if (obj[x].toISOString) string += `&${x}=${encodeURIComponent(obj[x].toISOString())}`
          else string += `&${x}=${encodeURIComponent(obj[x])}`
        }
      }
    })
  }
  return string.substr(1)
}
